'use strict';

var shippingAddressHelper = require('../../checkout/shippingAddress');
const $container = $('.delivery-check');
const $inputEle = $container.find('.delivery-check-input');
const $countryOptions = $container.find('.py-option-value');
const $deliveryCheckForm = $('.delivery-check-form');
const deliveryStatusContainer = $container.find('.delivery-status');
let lastWindowWidth = $(window).width();

/**
 * Updates the text of the label adjacent to the serviceability input
 * based on the selected country code and the serviceability field
 * @param {string} serviceabilityField - 'pincode' or 'city'
 * @param {string} countryCode - ISO code of the selected country
 */
function updateLabelText(serviceabilityField, countryCode) {
    const $label = $inputEle.siblings('label');
    if ($label.length) {
        if (serviceabilityField === 'pincode') {
            $label.text(countryCode === 'IN' ? 'Enter Pincode' : 'Enter Zipcode');
        } else {
            $label.text('Enter City');
        }
    }
}

/**
 * Sets attributes on the serviceability input element based on the
 * selected country code and chosen serviceability field (pincode or city)
 * @prop {string} type - input type (text or number)
 * @prop {string} checkField - serviceability field (pincode or city)
 * @prop {string} countryIsoCode - ISO code of the selected country
 * @prop {number} minLength - minimum length of the input
 * @prop {number} maxLength - maximum length of the input
 * @prop {string} regex - regex pattern to validate the input
 */
function setInputAttributes({
    type, checkField, countryIsoCode, minLength, maxLength, regex
}) {
    $inputEle.attr({
        'data-type': type || '',
        'data-checkfield': checkField || '',
        'data-isocode': countryIsoCode || '',
        minlength: minLength || '',
        maxlength: maxLength || '',
        pattern: regex || ''
    })
        .removeClass('is-invalid')
        .removeClass('has-value')
        .focus();
}

/**
 * Adjusts the width of the country options dropdown to match the width
 * of the serviceability input element. This ensures that the dropdown
 * aligns correctly with the input field for a consistent user interface.
 */
function handleDeliveryCheckOptions() {
    const $countryOptionsDiv = $container.find('.py-option-values');
    if ($countryOptionsDiv.length && $inputEle.length) {
        const inputWidth = $inputEle.outerWidth();
        $countryOptionsDiv.css('width', inputWidth);
    }
}

$countryOptions.on('click', function () {
    const $this = $(this);
    const optionData = {
        type: $this.data('type'),
        checkField: $this.data('check-field'),
        countryIsoCode: $this.data('value'),
        minLength: $this.data('min-length'),
        maxLength: $this.data('max-length'),
        regex: $this.data('regex')
    };

    updateLabelText(optionData.checkField, optionData.countryIsoCode);
    deliveryStatusContainer.empty();
    setInputAttributes(optionData);
});

$inputEle.on('input', function () {
    const $this = $(this);
    const inputType = $this.data('type');
    const inputVal = $this.val();
    let sanitizedVal = inputVal;

    if (inputType === 'number') {
        sanitizedVal = inputVal.replace(/[^0-9]/g, '');
    } else if (inputType === 'text') {
        sanitizedVal = inputVal.replace(/[^a-zA-Z\s]/g, '');
    }

    if (sanitizedVal !== inputVal) {
        $this.val(sanitizedVal);
    }

    if ($this.hasClass('is-invalid')) {
        $this.removeClass('is-invalid');
    }
});

$(document).ready(function () {
    handleDeliveryCheckOptions();
    const prefilledPincode = $inputEle.val();
    const prefilledCountry = $inputEle.data('isocode');
    const minLength = $inputEle.attr('minlength') || 6;
    if (prefilledPincode && prefilledCountry && prefilledPincode.length >= minLength) {
        $('.delivery-check-form').trigger('submit');
    }
});

$('.delivery-check-cta').on('click', function () {
    let pincode = $inputEle.val();
    if (pincode === '') {
        $inputEle.addClass('py-error');
        $('.delivery-check-error').html('Please enter a pincode');
        deliveryStatusContainer.empty();
    }
});

/**
 * On CTA click: validate, send AJAX, show result
 */
$deliveryCheckForm.on('submit', function (e) {
    e.preventDefault();
    const inputEl = $inputEle[0];
    const isPatternMismatch = inputEl.validity.patternMismatch;
    const isValueMissing = inputEl.validity.valueMissing;
    const isRangeError = inputEl.validity.tooLong || inputEl.validity.tooShort;
    const pincode = $inputEle.val().trim();

    if (isValueMissing || isPatternMismatch || isRangeError || shippingAddressHelper.isInvalidPincode(pincode)) {
        $('.delivery-check-error').html('Please enter a valid pincode');
        $inputEle.addClass('is-invalid');
        deliveryStatusContainer.empty();
        return;
    }

    const url = $deliveryCheckForm.attr('action') + '?' + $deliveryCheckForm.serialize();
    $.ajax({
        url: url,
        type: 'GET',
        success: function (data) {
            let message = '';
            $('.delivery-check-error').empty();
            $inputEle.removeClass('py-error');

            if (data.success && data.message) {
                message = `<div class="delivery-check-content-message"><span style="color:#28ba4f" class="delivery-check-message">${data.message || 'Contact customer service for expected delivery date.'}</span></div>
                    <div class="mobile-number"><a href="tel:+9144 40747576"><span class="platform-details">+91 44 40747576</span></a></div>`;
            } else if (data.success) {
                message = `<div class="delivery-check-content">Expected Delivery By <span class="delivery-check-date">${data.deliveryDate}</span></div>`;
            } else {
                message = `<div class="delivery-check-content-message"><span style="color:#28ba4f" class="delivery-check-message">${data.message || 'Contact customer service for expected delivery date.'}</span></div>
                    <div class="mobile-number"><a href="tel:+9144 40747576"><span class="platform-details">+91 44 40747576</span></a></div>`;
            }
            deliveryStatusContainer.empty().append(message);
            $('.price-section .delivery-status').empty().append(message);
        },
        error: function () {
            $('.delivery-check-error').html('Something went wrong');
        }
    });
});

$inputEle.on('keyup change', function () {
    const pincode = $inputEle.val().trim();

    if (pincode === '') {
        $inputEle.addClass('py-error');
        $('.delivery-check-error').html('Please enter a pincode');
        deliveryStatusContainer.empty();
        return;
    }

    if (pincode.length < 6 || shippingAddressHelper.isInvalidPincode(pincode)) {
        $inputEle.addClass('py-error');
        $('.delivery-check-error').html('Please enter a valid pincode');
        deliveryStatusContainer.empty();
        return;
    }

    $inputEle.removeClass('py-error');
    $('.delivery-check-error').empty();
});

$inputEle.on('keypress', function (e) {
    if (e.which === 13) {
        e.preventDefault();
        $('.delivery-check-form').trigger('submit');
    }
});

$(document).ready(function () {
    handleDeliveryCheckOptions();
});

$(window).on('resize', function () {
    const currentWidth = $(window).width();
    if (currentWidth !== lastWindowWidth) {
        lastWindowWidth = currentWidth;
        handleDeliveryCheckOptions();
    }
});
